import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'Components';

const FormikTextField = ({
  field,
  form,
  title,
  required,
  ...props
}) => (
  <div className="text-field">
    { title && <div className="text-field__label">{title}</div>}
    <Input required={required} {...field} {...props} />
    { required && <span className="text-field__required">*</span> }
    { form && form.touched[field.name] && form.errors[field.name] &&
      <div className="text-field__error">{ form.errors[field.name] }</div>}
  </div>
);

FormikTextField.propTypes = {
  field: PropTypes.shape({

  }),
  form: PropTypes.shape({
    touched: PropTypes.shape({}),
    errors: PropTypes.shape({}),
  }),
  required: PropTypes.bool,
  title: PropTypes.string,
};

export default FormikTextField;



// WEBPACK FOOTER //
// ./src/components/TextField/Formik.jsx